import { render, staticRenderFns } from "./WcLoadersInfiniteSpinner.vue?vue&type=template&id=6b186a3c&lang=pug&"
import script from "./WcLoadersInfiniteSpinner.vue?vue&type=script&lang=js&"
export * from "./WcLoadersInfiniteSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports